/* eslint-disable no-unused-vars */
import React from 'react';

const DoctorBoxPage = ({
  isEditing = false,
  setIsEditing,
  newMasterItem = '',
  setNewMasterItem,
  cabinet = '',
  setCabinet,
  shelf = '',
  setShelf,
  row = '',
  setRow,
  boxItemsRequirement,
  setBoxItemsRequirement,
  selectedComponents = [],
  setSelectedComponents,
  handleDoctorBoxReqChange,
  handleSelectAllDoctorBox,
  isUploading = false,
  handleImageUpload,
  imageUrl = '',
  setImageUrl,
  resetForm,
  handleSaveBox,
  itemMaster = [],
  supplies = [],
  instruments = [],
  startEdit,
  handleDeleteMaster,
  handlePrintBarcode,
  isPrinting = false,
  setPrintMode,
  setPackagingItem,
  setShowLabelPreview,
  setLabelPreviewData,
  generateUID,
  handleUnbindFromBox,
  handleDeleteDoctorBox,
  setSetCategory,
  setEditId,
}) => {
  // Helper to determine count of a given item in current selection / requirements
  const getComponentCount = (itemId) => {
    if (boxItemsRequirement !== undefined && boxItemsRequirement !== null) {
      if (typeof boxItemsRequirement === 'object' && !Array.isArray(boxItemsRequirement)) {
        return boxItemsRequirement[itemId] || 0;
      }
      if (Array.isArray(boxItemsRequirement)) {
        return boxItemsRequirement.filter(id => id === itemId).length;
      }
    }
    if (Array.isArray(selectedComponents)) {
      return selectedComponents.filter(id => id === itemId).length;
    }
    return 0;
  };

  const handleDecrement = (m) => {
    const count = getComponentCount(m.id);
    if (count <= 0) return;

    if (typeof handleDoctorBoxReqChange === 'function') {
      handleDoctorBoxReqChange(m.id, count - 1);
    }
    if (setBoxItemsRequirement) {
      if (typeof boxItemsRequirement === 'object' && !Array.isArray(boxItemsRequirement)) {
        setBoxItemsRequirement(prev => ({ ...prev, [m.id]: Math.max(0, (prev[m.id] || 0) - 1) }));
      } else if (Array.isArray(boxItemsRequirement)) {
        const newArr = [...boxItemsRequirement];
        const idx = newArr.indexOf(m.id);
        if (idx !== -1) newArr.splice(idx, 1);
        setBoxItemsRequirement(newArr);
      }
    }
    if (setSelectedComponents && Array.isArray(selectedComponents)) {
      const newArr = [...selectedComponents];
      const idx = newArr.indexOf(m.id);
      if (idx !== -1) {
        newArr.splice(idx, 1);
        setSelectedComponents(newArr);
      }
    }
  };

  const handleIncrement = (m) => {
    const count = getComponentCount(m.id);

    if (typeof handleDoctorBoxReqChange === 'function') {
      handleDoctorBoxReqChange(m.id, count + 1);
    }
    if (setBoxItemsRequirement) {
      if (typeof boxItemsRequirement === 'object' && !Array.isArray(boxItemsRequirement)) {
        setBoxItemsRequirement(prev => ({ ...prev, [m.id]: (prev[m.id] || 0) + 1 }));
      } else if (Array.isArray(boxItemsRequirement)) {
        setBoxItemsRequirement(prev => [...prev, m.id]);
      }
    }
    if (setSelectedComponents) {
      setSelectedComponents(prev => [...(prev || []), m.id]);
    }
  };

  const handleEditBox = (boxTemplate) => {
    if (typeof startEdit === 'function') {
      startEdit(boxTemplate);
    } else {
      if (setSetCategory) setSetCategory('กล่องหัวกรอ');
      if (setEditId) setEditId(boxTemplate.id);
      if (setNewMasterItem) setNewMasterItem(boxTemplate.item_name);
      if (setCabinet) setCabinet(boxTemplate.cabinet || '');
      if (setShelf) setShelf(boxTemplate.shelf || '');
      if (setRow) setRow(boxTemplate.row || '');
      if (setImageUrl) setImageUrl(boxTemplate.image_url || '');
      if (setSelectedComponents) setSelectedComponents(boxTemplate.components || []);
      if (setIsEditing) setIsEditing(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleDeleteBox = (boxTemplate) => {
    if (window.confirm(`ลบกล่อง ${boxTemplate.item_name} ใช่หรือไม่?\n(คำเตือน: หัวกรอที่เคยอยู่ในกล่องจะถูกนำออกจากกล่อง)`)) {
      if (typeof handleDeleteDoctorBox === 'function') {
        handleDeleteDoctorBox(boxTemplate.id);
      } else if (typeof handleDeleteMaster === 'function') {
        handleDeleteMaster(boxTemplate.id);
      }
    }
  };

  const handlePrint = (boxItem) => {
    if (typeof handlePrintBarcode === 'function') {
      handlePrintBarcode(boxItem);
    } else if (typeof setShowLabelPreview === 'function') {
      if (typeof setPackagingItem === 'function') setPackagingItem(boxItem);
      if (typeof setPrintMode === 'function') setPrintMode('single');
      if (typeof setLabelPreviewData === 'function') setLabelPreviewData(boxItem);
      setShowLabelPreview(true);
    } else {
      if (boxItem?.unique_barcode) {
        navigator.clipboard.writeText(boxItem.unique_barcode);
        alert(`📋 รหัสกล่อง: ${boxItem.unique_barcode}`);
      }
    }
  };

  return (
    <div>
      <div style={{ background: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
          <h2 style={{ margin: 0, color: '#00695c' }}>🧰 จัดการกล่องหัวกรอ (Container)</h2>
        </div>
        <p style={{ color: '#666', fontSize: '0.95em' }}>กล่องแต่ละใบทำหน้าที่เป็น &quot;แม่กลุ่ม&quot; (Container) คุณสามารถกำหนดได้ว่ากล่องใบนั้นควรมีหัวกรออะไรบ้าง และจำนวนกี่ชิ้น</p>

        {/* ฟอร์มตั้งค่ากล่อง */}
        <div style={{ background: '#e0f2f1', padding: '20px', borderRadius: '10px', marginBottom: '30px', border: '2px solid #009688', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginTop: 0, color: '#004d40', display: 'flex', justifyContent: 'space-between' }}>
            <span>{isEditing ? `⚙️ แก้ไขกล่อง: ${newMasterItem}` : '➕ เพิ่มกล่องใบใหม่'}</span>
            {isEditing && <span style={{ fontSize: '0.7em', background: '#b2dfdb', padding: '5px 10px', borderRadius: '12px', color: '#00695c' }}>กำลังแก้ไขแม่แบบกล่อง</span>}
          </h3>

          <input
            placeholder="ชื่อกล่อง (เช่น กล่องหมอ A, กล่อง Endo 1)..."
            value={newMasterItem}
            onChange={(e) => setNewMasterItem && setNewMasterItem(e.target.value)}
            style={{ width: '100%', marginBottom: '15px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '1.1em', fontWeight: 'bold' }}
          />

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '10px', marginBottom: '15px' }}>
            <input value={cabinet} onChange={(e) => setCabinet && setCabinet(e.target.value)} placeholder="ระบุตู้ (เช่น ตู้ 1)" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }} />
            <input value={shelf} onChange={(e) => setShelf && setShelf(e.target.value)} placeholder="ระบุชั้น (เช่น ชั้น A)" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }} />
            <input value={row} onChange={(e) => setRow && setRow(e.target.value)} placeholder="ระบุแถว (เช่น แถว 2)" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }} />
          </div>

          <div style={{ marginBottom: '15px', padding: '15px', background: '#fff', border: '1px dashed #ccc', borderRadius: '8px' }}>
            <label style={{ fontWeight: 'bold', color: '#00695c' }}>📸 รูปภาพอ้างอิงของกล่อง (ถ้ามี):</label>
            <input type="file" accept="image/*" onChange={handleImageUpload} style={{ display: 'block', marginTop: '10px' }} />
            {isUploading && <p style={{ color: '#f39c12' }}>⏳ กำลังอัปโหลด...</p>}
            {imageUrl && <img src={imageUrl} alt="box-preview" style={{ maxWidth: '150px', marginTop: '10px', borderRadius: '5px', border: '1px solid #ddd' }} />}
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
            <label style={{ fontWeight: 'bold', color: '#00695c', display: 'block' }}>👇 กำหนดจำนวนอุปกรณ์ที่ต้องมีในกล่องนี้ (บวก/ลบจำนวน):</label>
            {typeof handleSelectAllDoctorBox === 'function' && (
              <button
                type="button"
                onClick={handleSelectAllDoctorBox}
                style={{ background: '#00796b', color: '#fff', border: 'none', borderRadius: '4px', padding: '4px 10px', fontSize: '0.85em', cursor: 'pointer', fontWeight: 'bold' }}
              >
                เลือกทั้งหมด
              </button>
            )}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '10px', maxHeight: '350px', overflowY: 'auto', padding: '15px', border: '1px solid #ccc', background: '#fff', borderRadius: '8px' }}>
            {/* 🌟 แสดงรายการหัวกรอ และชุดหัวกรอ พร้อมปุ่มกดเพิ่ม/ลดจำนวน */}
            {itemMaster.filter(m => m.category === 'หัวกรอ').map(m => {
              const count = getComponentCount(m.id);
              const isSelected = count > 0;

              return (
                <div key={m.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', padding: '10px 15px', border: `1px solid ${isSelected ? '#009688' : '#eee'}`, borderRadius: '6px', background: isSelected ? '#e0f2f1' : '#fafafa' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, flexWrap: 'wrap' }}>
                    <span style={{ fontWeight: isSelected ? 'bold' : 'normal', color: isSelected ? '#00695c' : '#333' }}>
                      {m.is_set ? '📦 (ชุด) ' : '🦷 '}{m.item_name}
                    </span>

                    {/* 🌟 ส่วนแสดงรูปภาพเล็กๆ ต่อท้ายชื่อ */}
                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                      {!m.is_set && m.image_url && (
                        <img src={m.image_url} title={m.item_name} alt="img" style={{ width: '28px', height: '28px', objectFit: 'contain', borderRadius: '4px', border: '1px solid #ccc', background: '#fff' }} />
                      )}

                      {m.is_set && m.components && m.components.map((compId, idx) => {
                        const compItem = itemMaster.find(i => i.id === compId);
                        if (compItem && compItem.image_url) {
                          return <img key={idx} src={compItem.image_url} title={compItem.item_name} alt="img" style={{ width: '28px', height: '28px', objectFit: 'contain', borderRadius: '4px', border: '1px solid #ccc', background: '#fff' }} />;
                        }
                        return null;
                      })}
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        handleDecrement(m);
                      }}
                      style={{ background: '#ffcc80', color: '#e65100', border: 'none', borderRadius: '50%', width: '30px', height: '30px', cursor: count > 0 ? 'pointer' : 'not-allowed', fontWeight: 'bold', fontSize: '1.2em', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                      disabled={count === 0}
                    >-</button>
                    <span style={{ fontWeight: 'bold', fontSize: '1.3em', minWidth: '25px', textAlign: 'center', color: '#00695c' }}>{count}</span>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        handleIncrement(m);
                      }}
                      style={{ background: '#81c784', color: '#1b5e20', border: 'none', borderRadius: '50%', width: '30px', height: '30px', cursor: 'pointer', fontWeight: 'bold', fontSize: '1.2em', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                    >+</button>
                  </div>
                </div>
              );
            })}
            {itemMaster.filter(m => m.category === 'หัวกรอ').length === 0 && <div style={{ color: '#999' }}>ไม่มีหัวกรอหรือชุดหัวกรอในระบบ</div>}
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
            <button onClick={resetForm} style={{ padding: '12px 20px', background: '#95a5a6', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>ล้างฟอร์ม/ยกเลิก</button>
            <button onClick={handleSaveBox} style={{ padding: '12px 30px', background: '#00796b', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '1.1em', fontWeight: 'bold' }}>{isEditing ? 'อัปเดตกล่อง' : 'บันทึกและสร้างกล่องใบใหม่'}</button>
          </div>
        </div>

        {/* 🌟 วนลูปแสดงกล่องทั้งหมดแบบ 1-to-1 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {itemMaster.filter(m => m.category === 'กล่องหัวกรอ').sort((a, b) => a.item_name.localeCompare(b.item_name)).map(boxTemplate => {
            // หา Physical Box ในระบบที่ลิงก์กับ master นี้
            const physicalBox = instruments.find(i => i.master_id === boxTemplate.id && i.unique_barcode?.startsWith('BOX-'));
            const boxBarcode = physicalBox ? physicalBox.unique_barcode : 'กำลังสร้าง...';

            // หาหัวกรอทั้งหมดที่อยู่ในกล่องนี้
            const itemsInside = physicalBox ? instruments.filter(i => i.container_code === physicalBox.unique_barcode && i.is_active) : [];

            // 🌟 คำนวณความต้องการ (Requirements) โดยนับความถี่ของ ID
            const requiredItemsMap = {};
            boxTemplate.components?.forEach(compId => {
              requiredItemsMap[compId] = (requiredItemsMap[compId] || 0) + 1;
            });

            // 🌟 คำนวณของที่มีอยู่จริง (Actuals)
            const actualItemsMap = {};
            const extraItemsList = [];
            itemsInside.forEach(inst => {
              if (requiredItemsMap[inst.master_id]) {
                actualItemsMap[inst.master_id] = (actualItemsMap[inst.master_id] || 0) + 1;
              } else {
                extraItemsList.push(inst);
              }
            });

            const mergedComponentIds = Object.keys(requiredItemsMap);

            return (
              <div key={boxTemplate.id} style={{ border: '2px solid #b2dfdb', borderRadius: '8px', background: '#e0f2f1', overflow: 'hidden', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                {/* Header ของกล่อง */}
                <div style={{ padding: '15px 20px', background: '#00796b', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px', fontSize: '1.3em', fontWeight: 'bold' }}>
                    🧰 {boxTemplate.item_name}
                    {physicalBox && <span style={{ fontSize: '0.7em', background: '#004d40', padding: '4px 10px', borderRadius: '12px', letterSpacing: '1px' }}>{boxBarcode}</span>}
                  </div>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    {physicalBox && (
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(physicalBox.unique_barcode);
                          alert(`📋 คัดลอกรหัส ${physicalBox.unique_barcode} เรียบร้อยแล้ว`);
                        }}
                        style={{ background: '#4db6ac', color: '#fff', border: 'none', padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
                      >
                        📋 คัดลอกรหัสกล่อง
                      </button>
                    )}

                    {physicalBox && (
                      <button
                        onClick={() => handlePrint(physicalBox)}
                        disabled={isPrinting}
                        style={{ background: '#0288d1', color: '#fff', border: 'none', padding: '6px 15px', borderRadius: '5px', cursor: isPrinting ? 'not-allowed' : 'pointer', fontWeight: 'bold' }}
                      >
                        {isPrinting ? '⏳ กำลังพิมพ์...' : '🖨️ พิมพ์บาร์โค้ด'}
                      </button>
                    )}

                    <button
                      onClick={() => handleEditBox(boxTemplate)}
                      style={{ background: '#fff', color: '#00796b', border: 'none', padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      ⚙️ ตั้งค่ากล่อง
                    </button>

                    <button
                      onClick={() => handleDeleteBox(boxTemplate)}
                      style={{ background: '#e74c3c', color: '#fff', border: 'none', padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      🗑️ ลบกล่อง
                    </button>
                  </div>
                </div>

                <div style={{ padding: '20px', background: '#fff', display: 'flex', gap: '20px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                  {/* ฝั่งซ้าย: โชว์รูปกล่อง และ อุปกรณ์ที่ต้องการตามแม่แบบ */}
                  <div style={{ flex: '1 1 300px' }}>
                    {boxTemplate.image_url && (
                      <div style={{ marginBottom: '15px' }}>
                        <img src={boxTemplate.image_url} alt="box" style={{ maxWidth: '100%', maxHeight: '150px', borderRadius: '8px', border: '1px solid #ccc' }} />
                      </div>
                    )}
                    <h4 style={{ marginTop: 0, color: '#004d40', borderBottom: '2px solid #b2dfdb', paddingBottom: '5px' }}>📋 อุปกรณ์ที่กำหนดไว้ในแม่แบบ</h4>
                    {mergedComponentIds.length > 0 ? (
                      <ul style={{ margin: 0, paddingLeft: '20px', color: '#555', fontSize: '0.95em', lineHeight: '1.6' }}>
                        {mergedComponentIds.map(compId => {
                          const compItem = itemMaster.find(i => i.id === compId);
                          const reqQty = requiredItemsMap[compId];
                          return <li key={compId}><strong>{reqQty} {compItem?.is_set ? 'ชุด' : 'ชิ้น'}</strong> - {compItem?.item_name || 'Unknown'}</li>;
                        })}
                      </ul>
                    ) : (
                      <div style={{ color: '#999', fontSize: '0.9em' }}>ยังไม่ได้กำหนดหัวกรอ (กดปุ่มตั้งค่ากล่อง)</div>
                    )}
                  </div>

                  {/* ฝั่งขวา: ตารางโชว์ของในกล่องจริงๆ แบบ Grid (คล้ายหน้า Order) */}
                  <div style={{ flex: '2 1 400px', background: '#f8f9fa', padding: '15px', borderRadius: '8px', border: '1px solid #ddd' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #009688', paddingBottom: '10px', marginBottom: '15px', flexWrap: 'wrap', gap: '10px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <h4 style={{ margin: 0, color: '#2c3e50' }}>📦 มีหัวกรออยู่จริงตอนนี้: <span style={{ color: '#00695c', fontSize: '1.2em' }}>{itemsInside.length}</span> ชิ้น</h4>
                        {typeof handleUnbindFromBox === 'function' && itemsInside.length > 0 && (
                          <button
                            type="button"
                            onClick={() => {
                              if (window.confirm(`ต้องการนำอุปกรณ์ทั้งหมด (${itemsInside.length} ชิ้น) ออกจากกล่อง ${boxTemplate.item_name} ใช่หรือไม่?`)) {
                                itemsInside.forEach(inst => handleUnbindFromBox(inst));
                              }
                            }}
                            style={{ background: '#ffebee', color: '#c62828', border: '1px solid #ffcdd2', padding: '3px 8px', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8em', fontWeight: 'bold' }}
                          >
                            🔓 ปลดทั้งหมด
                          </button>
                        )}
                      </div>

                      {physicalBox && (
                        <span style={{ fontSize: '0.85em', background: physicalBox.status === 'in-use' ? '#e3f2fd' : '#e8f5e9', color: physicalBox.status === 'in-use' ? '#0288d1' : '#2e7d32', padding: '6px 12px', borderRadius: '15px', fontWeight: 'bold' }}>
                          📍 สถานะกล่อง: {physicalBox.status === 'in-use' ? `จ่ายไป ${(physicalBox.location || '').replace('- ', '').trim()}` : '✅ อยู่ในห้อง Sterile'}
                        </span>
                      )}
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '15px' }}>
                      {mergedComponentIds.length === 0 ? (
                        <div style={{ color: '#999', padding: '20px', textAlign: 'center', gridColumn: '1/-1' }}>ยังไม่ได้กำหนดหัวกรอ (กดปุ่ม ⚙️ ตั้งค่ากล่อง ด้านบน)</div>
                      ) : (
                        mergedComponentIds.map(compId => {
                          const compMaster = itemMaster.find(i => i.id === compId);
                          if (!compMaster) return null;

                          const requiredQty = requiredItemsMap[compId] || 0;
                          const actualQty = actualItemsMap[compId] || 0;
                          const isComplete = actualQty >= requiredQty;
                          const missingQty = requiredQty - actualQty;
                          const matchedInside = itemsInside.filter(inst => inst.master_id === compId);

                          return (
                            <div key={compId} style={{ padding: '15px', border: isComplete ? '2px solid #a5d6a7' : '2px solid #ffcc80', borderRadius: '10px', background: isComplete ? '#f1f8e9' : '#fff3e0', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                                <strong style={{ fontSize: '1.1em', color: '#2c3e50' }}>
                                  {compMaster.is_set ? '📦' : '🦷'} {compMaster.item_name}
                                </strong>
                                {compMaster.image_url && <img src={compMaster.image_url} alt={compMaster.item_name} style={{ width: '45px', height: '45px', objectFit: 'contain', borderRadius: '5px', border: '1px solid #ccc', background: '#fff' }} />}
                              </div>

                              <div style={{ fontSize: '1.2em', fontWeight: 'bold', color: isComplete ? '#2e7d32' : '#e65100', marginBottom: '8px' }}>
                                มีในกล่อง: {actualQty} / {requiredQty}
                              </div>

                              {!isComplete && (
                                <div style={{ padding: '6px 10px', background: '#ffebee', color: '#c62828', borderRadius: '5px', fontSize: '0.85em', fontWeight: 'bold', display: 'inline-block' }}>
                                  ⚠️ ขาด {missingQty} {compMaster.is_set ? 'ชุด' : 'ชิ้น'} (ต้องใส่ทดแทน)
                                </div>
                              )}
                              {actualQty > requiredQty && (
                                <div style={{ padding: '6px 10px', background: '#e3f2fd', color: '#0288d1', borderRadius: '5px', fontSize: '0.85em', fontWeight: 'bold', display: 'inline-block', marginTop: '5px' }}>
                                  ℹ️ ใส่เกินมา {actualQty - requiredQty} {compMaster.is_set ? 'ชุด' : 'ชิ้น'}
                                </div>
                              )}

                              {/* รายการ barcode ของอุปกรณ์ที่อยู่ในกล่องพร้อมปุ่ม unbind */}
                              {matchedInside.length > 0 && (
                                <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                  {matchedInside.map(inst => (
                                    <div key={inst.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.8em', background: '#fff', padding: '3px 8px', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
                                      <span style={{ fontFamily: 'monospace', color: '#555' }}>🏷️ {inst.unique_barcode}</span>
                                      {typeof handleUnbindFromBox === 'function' && (
                                        <button
                                          type="button"
                                          onClick={() => handleUnbindFromBox(inst)}
                                          style={{ background: '#ffebee', color: '#c62828', border: '1px solid #ffcdd2', borderRadius: '3px', padding: '1px 6px', cursor: 'pointer', fontSize: '0.85em' }}
                                          title="ปลดชิ้นนี้ออกจากกล่อง"
                                        >
                                          ปลดออก
                                        </button>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        })
                      )}
                    </div>

                    {/* แจ้งเตือนของแปลกปลอม (ถ้ามี) */}
                    {extraItemsList.length > 0 && (
                      <div style={{ marginTop: '20px', padding: '15px', background: '#ffebee', border: '1px dashed #ef9a9a', borderRadius: '8px' }}>
                        <h4 style={{ margin: '0 0 10px 0', color: '#c62828' }}>⚠️ อุปกรณ์ที่ไม่มีในแม่แบบ (หลงสแกนเข้ามา):</h4>
                        {extraItemsList.map((inst, i) => {
                          const isSet = itemMaster.find(m => m.id === inst.master_id)?.is_set;
                          return (
                            <div key={i} style={{ fontSize: '0.95em', color: '#d35400', padding: '3px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span>- {isSet ? '📦' : '🦷'} {inst.item_name} <span style={{ fontFamily: 'monospace', color: '#999' }}>({inst.unique_barcode})</span></span>
                              {typeof handleUnbindFromBox === 'function' && (
                                <button
                                  type="button"
                                  onClick={() => handleUnbindFromBox(inst)}
                                  style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: '4px', padding: '2px 8px', fontSize: '0.8em', cursor: 'pointer' }}
                                >
                                  ปลดออกจากกล่อง
                                </button>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}

                  </div>
                </div>
              </div>
            );
          })}

          {itemMaster.filter(m => m.category === 'กล่องหัวกรอ').length === 0 && (
            <div style={{ textAlign: 'center', padding: '40px', color: '#7f8c8d', background: '#f8f9fa', borderRadius: '10px', border: '2px dashed #bdc3c7' }}>
              <div style={{ fontSize: '3em', marginBottom: '10px' }}>📦</div>
              ยังไม่มีการสร้างกล่อง<br />เพิ่มกล่องใบแรกในฟอร์มด้านบนเพื่อเริ่มต้นใช้งาน
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DoctorBoxPage;
